import React from 'react'
import { QRCodeSVG } from 'qrcode.react'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'

import CloseRoundedIcon from '@mui/icons-material/CloseRounded'

// import logoSrc from '@/assets/img/logo.png'

export type QrCodeDialogProps = {
  onClose?: () => void
  open: boolean
  qrCodeValue: string
}

export function QrCodeDialog(props: QrCodeDialogProps) {
  const { onClose, open, qrCodeValue } = props

  return (
    <Dialog onClose={onClose} open={open}>
      <Stack direction="row" alignItems="center" justifyContent="end" mt="12px" mr="12px">
        <IconButton onClick={onClose}>
          <CloseRoundedIcon />
        </IconButton>
      </Stack>
      <DialogContent>
        <QRCodeSVG
          // removed image because detection is much faster without it 
          includeMargin
          level="L"
          size={256}
          value={qrCodeValue}
        />
      </DialogContent>
    </Dialog>
  )
}

export default QrCodeDialog
